/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const EnumAuditExtendAction = {
    Create: 'create',
    Update: 'update',
    Destroy: 'destroy'
};
export function EnumAuditExtendActionFromJSON(json) {
    return EnumAuditExtendActionFromJSONTyped(json, false);
}
export function EnumAuditExtendActionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function EnumAuditExtendActionToJSON(value) {
    return value;
}
